import { l10n } from '@ott/l10n';
import * as yup from 'yup';

const cardHolderRegExp = /^[A-Za-z\s-]*$/;

export const getCardHolderValidation = () => {
  return yup
    .string()
    .required(l10n('required.required'))
    .test((cardHolder = '', { createError, path }) => {
      const isValid = cardHolderRegExp.test(cardHolder);

      if (!isValid) {
        return createError({
          message: l10n('wrong.cardHolder'),
          path,
        });
      }

      return true;
    });
};
